import Styles from "./styles";
import ui from "components/ui";

// img
import IconClose from "resources/image/icon/icon_close.svg";

function VrSelectModal({ modalOption, modalClose }) {
  const handleLanguageClick = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
    modalClose();
  };

  return (
    <Styles.Container>
      <div className="modalInner">
        <button
          type="button"
          className="closeButton"
          onClick={() => {
            modalClose();
          }}
        >
          <img src={IconClose} alt="IconClose" />
        </button>

        <p className="modalText">{modalOption.text || "언어를 선택해주세요"}</p>

        <div className="buttonGroup">
          <ui.button.BasicButton
            buttonText="한국어"
            onClick={() =>
              handleLanguageClick("https://www.enertork.com/vr/index.html")
            }
          />
          <ui.button.BasicButton
            buttonText="English"
            onClick={() =>
              handleLanguageClick("https://www.enertork.com/vr/indexe.html")
            }
          />
          <ui.button.BasicButton
            buttonText="Русский"
            onClick={() =>
              handleLanguageClick("https://www.enertork.com/vr/indexr.html")
            }
          />
        </div>
      </div>

      <div className="overlay" onClick={modalClose}></div>
    </Styles.Container>
  );
}

export { VrSelectModal };

export default VrSelectModal;
